const PACKAGE_TYPE_DISPLAY_LABELS = {
  'Standalone': 'Standalone Package',
  'First Part': 'Split Package First Part',
  'Intermediate': 'Split Package Intermediate',
  'Last Part': 'Split Package Last Part',
}

const packageTypeDisplay = (value) => {
  if (!value || value === '****') return value
  return PACKAGE_TYPE_DISPLAY_LABELS[value] ?? value
}

const healthChecksSchema = ({ data, headers }) => {
  const status = data.vendor_status
  return (
    <tr className='text-gray-600'>
      {headers.map((key) => {
        switch (key.toUpperCase()) {
          case 'EMPLOYEE ID':
            return <td className='pl-3 pr-5 py-5'>{data.employee_id}</td>

          case 'EMPLOYEE DETAILS':
            return (
              <td className='pl-3 pr-5 py-5 '>
                <p className='font-semibold mb-0 inline-block mr-2'>{data.customer_name}</p>
                {data.customer_active && <span className='px-2 inline-flex leading-6 font-semibold rounded-full bg-green-100 text-green-700'>Active</span>}
                <p className='mb-0'>{data.customer_email}</p>
              </td>
            )

          case 'CUSTOMER TYPE':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{data.customer_type}</span>
              </td>
            )

          case 'APPOINTMENT DATE & ID':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{data.appointment_date}</span>
                <br />
                <span>{data.unique_id}</span>
              </td>
            )
          case 'ORDER DATE & ID':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{data.appointment_date}</span>
                <br />
                <span>{data.unique_id}</span>
              </td>
            )
          case 'PROVIDER':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{data.provider_name}</span>
                <br />
                <span>{data.provider_city}</span>
              </td>
            )

          case 'APPOINTMENT STATUS':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span className='px-2 inline-flex leading-7 font-semibold rounded-full bg-green-100 text-green-700'>{status === 'received' ? 'completed' : status}</span>
              </td>
            )
            
          case 'ORDER STATUS':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span className='px-2 inline-flex leading-7 font-semibold rounded-full bg-green-100 text-green-700'>{status === 'delivered' ? 'completed' : status}</span>
              </td>
            )

          case 'PACKAGE NAME & AMOUNT':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{data.package_name}</span>
                <br />
                <span>&#8377;{data.package_mrp}</span>
              </td>
            )
          case 'ITEM NAME & AMOUNT':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{data.package_name}</span>
                <br />
                <span>&#8377;{data.package_mrp}</span>
              </td>
            )

          case 'PACKAGE TYPE':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{packageTypeDisplay(data.package_type)}</span>
              </td>
            )

          case 'PAYMENT TYPE':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{data.payment_type_display}</span>
              </td>
            )

          case 'DATE OF BIRTH':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{data.customer_dob}</span>
              </td>
            )

          case 'GENDER':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{data.customer_gender}</span>
              </td>
            )

          case 'RELATION':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{data.relation}</span>
              </td>
            )

          case 'SPONSOR DEPARTMENT':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{data.customer_department}</span>
              </td>
            )

          case 'ENTITY':
            return (
              <td className='pl-3 pr-5 py-5'>
                <span>{data.entity}</span>
              </td>
            )
        }
      })}
    </tr>
  )
}

export default healthChecksSchema